import React from 'react';
import {AppBar, Box, Button, Container, Menu, MenuItem, Stack, Toolbar, Typography} from '@mui/material';
import IconButton from '@mui/material/IconButton';
import MenuIcon from '@mui/icons-material/Menu';
import logo from '../../images/logo.png';
import {Link} from 'react-router-dom';

const pages = [ // for the mobile "hamburger" menu  
{"text": "Home", "link": "/"}, 
{"text": "VR Games", "link": "/VR"}, 
{"text": "FAQ", "link": "/FAQ"}, 
{"text": "Parties", "link": "/Parties"}, 
{"text": "Corporate Events", "link": "/Corporate"},
{"text": "Vouchers", "link": "/Vouchers"},
{"text": "BOOK NOW", "link": "/VR"},
]
const games = [
  {"text": "Depths Of Osiris", "link": "/Osiris"}, 
  {"text": "Dragon Tower", "link": "/Dragon"}, 
  {"text": "Laserbots", "link": "/Laserbots"}, 
  {"text": "Manor of Escape", "link": "/Manor"}, 
  {"text": "Pirate's Plague", "link": "/Pirates"},
  {"text": "Runaway Train", "link": "/RunawayTrain"},
  {"text": "Space Station Tiberia", "link": "/Tiberia"},
  {"text": "Time Travel Paradox", "link": "/TimeTravel"},
]
const events = [
  {"text": "Parties", "link": "/Parties"}, 
  {"text": "Corporate Events", "link": "/Corporate"}, 
]
export const TopBar = () => {
  const [anchorElNav, setAnchorElNav] = React.useState(null); //for hamburger menu
  const [anchorElG, setAnchorElG] = React.useState(null); //for game dropdown menu
  const [anchorElE, setAnchorElE] = React.useState(null); //for event dropdown menu
  const openg = Boolean(anchorElG);
  const opene = Boolean(anchorElE);

  const handleOpenNavMenu = (event) => {
    setAnchorElNav(event.currentTarget);
  };
  const handleCloseNavMenu = () => {
    setAnchorElNav(null);
  };
  const handleClickG = (event) => {
     setAnchorElG(event.currentTarget);
  }
  const handleCloseG = () => {
    setAnchorElG(null);
  }
  const handleClickE = (event) => {
    setAnchorElE(event.currentTarget);
 }
 const handleCloseE = () => {
   setAnchorElE(null);
 }
  return (
    <>
      <AppBar>
          <Toolbar disableGutters style={{color:"black"}}>
            <Box sx={{display:"flex", flexGrow:1}}>
                <Link to = "/">
                  <img src={logo} alt="logo" style={{ width:"100%", height:"auto"}}/>
                </Link>
            </Box>
          <Box sx={{ flexGrow: 1, display: { xs: 'flex', md: 'none' } }} justifyContent="right">
            <IconButton
              size="large"
              aria-label="account of current user"
              aria-controls="menu-appbar"
              aria-haspopup="true"
              onClick={handleOpenNavMenu}
              color="inherit"
            >
              <MenuIcon />
            </IconButton>
            <Menu
              id="menu-appbar"
              anchorEl={anchorElNav}
              anchorOrigin={{
                vertical: 'bottom',
                horizontal: 'left',
              }}
              keepMounted
              transformOrigin={{
                vertical: 'top',
                horizontal: 'left',
              }}
              open={Boolean(anchorElNav)}
              onClose={handleCloseNavMenu}
              sx={{
                display: { xs: 'block', md: 'none' },
              }}
            >
              {pages.map((page) => (
                <MenuItem key={page} onClick={handleCloseNavMenu} component={Link} reloadDocument to={page.link}>
                  <Typography textAlign="center" fontFamily={"Copperplate"}>{page.text}</Typography>
                </MenuItem>
              ))}
            </Menu>
          </Box>
          <Box sx={{ flexGrow: 1, display: { xs: 'none', md: 'flex' }, marginRight:"20px" }} justifyContent="right"> 
                <Stack direction="row" spacing = {2}>
                <Button variant = "contained" component={Link} reloadDocument to ="/" style={{backgroundColor:"#e6aa56", color:"black", borderRadius:"20px"}}><Typography variant = "caption" fontFamily={"Copperplate"}>HOME</Typography></Button>
                    <Button variant = "contained" style={{backgroundColor:"#e6aa56", color:"black", borderRadius:"20px"}}onClick={handleClickG}>
                      <Typography variant = "caption" fontFamily={"Copperplate"}>Games</Typography>
                      </Button>
                      <Menu anchorEl={anchorElG} open = {openg} onClose= {handleCloseG}>
                          {games.map((game) => (
                            <MenuItem key = {game} component={Link} reloadDocument to={game.link}>
                              <Typography fontFamily={"Copperplate"}>{game.text} </Typography>
                            </MenuItem>
                          ))}
                    </Menu> 
                    <Button variant = "contained" component = {Link} to = "/FAQ" style={{backgroundColor:"#e6aa56", color:"black", borderRadius:"20px"}}>
                      <Typography variant = "caption" fontFamily={"Copperplate"}>FAQ</Typography>
                    </Button>
                    <Button variant = "contained" style={{backgroundColor:"#e6aa56", color:"black", borderRadius:"20px"}}onClick={handleClickE}>
                      <Typography variant = "caption" fontFamily={"Copperplate"}>Events</Typography>
                      </Button>
                      <Menu anchorEl={anchorElE} open = {opene} onClose= {handleCloseE}>
                          {events.map((event) => (
                            <MenuItem key = {event} component={Link} reloadDocument to={event.link}>
                              <Typography fontFamily={"Copperplate"}>{event.text} </Typography>
                            </MenuItem>
                          ))}
                    </Menu> 
                    <Button variant = "contained" component = {Link} to = "/Vouchers" style={{backgroundColor:"#e6aa56", color:"black", borderRadius:"20px"}}>
                      <Typography variant = "caption" fontFamily={"Copperplate"}>Vouchers</Typography>
                      </Button>
                    <Button variant = "contained" component = {Link} reloadDocument to ="/VR" style={{backgroundColor:"black", color:"#e6aa56", borderRadius:"20px"}}>
                      <Typography variant = "caption" fontFamily={"Copperplate"}>BOOK NOW</Typography>
                      </Button>
                </Stack>
          </Box>
          </Toolbar>
      </AppBar>
      <Container style={{paddingTop:"79.5px"}}></Container>
      </>
  )
}
